export async function syncDataDealers() {
  try {
    const response = await fetch(`/internal-api/dealer/dms/import`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    try {
      return await response.json();
    } catch {
      return { success: true };
    }
  } catch (error) {
    console.error("Ошибка при обновлении ожиданий: ", error);
    throw error;
  }
}
